import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { DatasourcesByOrganizationDocument, } from '../../generated/graphql';
import StyledLink from '../components/StyledLink';
import { Grid, Button, Table, TableRow, TableCell, TableBody, TableHead } from '@material-ui/core';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';
var Datasources = function (props) {
    var query = new URLSearchParams(props.location.search);
    var organizationId = query.get('org');
    var _a = useState(), sources = _a[0], setSources = _a[1];
    var _b = useQuery(DatasourcesByOrganizationDocument, {
        variables: { organizationId: organizationId },
        fetchPolicy: 'cache-and-network',
    }), data = _b.data, loading = _b.loading, error = _b.error;
    useEffect(function () {
        if (data) {
            setSources(data.datasourcesByOrganization);
        }
    }, [data]);
    return (React.createElement(PageLayout, null,
        React.createElement(PageTitle, { title: "Data Sources" }),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Button, { variant: "contained", color: "primary" },
                React.createElement(StyledLink, { to: "/datasources/new" }, "Add Data Source"))),
        sources ? (React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "Name"))),
            React.createElement(TableBody, null, sources.map(function (source, i) { return (React.createElement(TableRow, { key: i },
                React.createElement(TableCell, null,
                    React.createElement(StyledLink, { to: "/datasources/" + source.id + "/edit" }, source.name)))); })))) : null));
};
export default Datasources;
